import { _ as _objectWithoutPropertiesLoose, a as _objectSpread2 } from '../_rollupPluginBabelHelpers-1f0bf8c2.js';
import { createComponent } from 'reakit-system/createComponent';
import { createHook } from 'reakit-system/createHook';
import 'reakit-utils/shallowEqual';
import { useBox } from '../Box/Box.js';
import { useCallback } from 'react';
import { useLiveRef } from 'reakit-utils/useLiveRef';
import 'reakit-utils/useSealedState';
import '../Id/IdProvider.js';
import '../Id/IdState.js';
import 'reakit-utils/useUpdateEffect';
import 'reakit-utils/isPromise';
import 'reakit-utils/isEmpty';
import 'reakit-utils/isPlainObject';
import { unstable_useFormState } from './FormState.js';
import 'reakit-utils/isObject';
import './utils/setAllIn.js';
import './utils/getIn.js';
import 'reakit-utils/toArray';
import 'reakit-utils/isInteger';
import './utils/setIn.js';

var unstable_useForm = createHook({
  name: "Form",
  compose: useBox,
  useState: unstable_useFormState,
  useProps: function useProps(options, _ref) {
    var htmlOnSubmit = _ref.onSubmit,
        htmlProps = _objectWithoutPropertiesLoose(_ref, ["onSubmit"]);

    var onSubmitRef = useLiveRef(htmlOnSubmit);
    var onSubmit = useCallback(function (event) {
      var _onSubmitRef$current, _options$submit;

      (_onSubmitRef$current = onSubmitRef.current) === null || _onSubmitRef$current === void 0 ? void 0 : _onSubmitRef$current.call(onSubmitRef, event);
      if (event.defaultPrevented) return;
      event.preventDefault();
      (_options$submit = options.submit) === null || _options$submit === void 0 ? void 0 : _options$submit.call(options);
    }, [options.submit]);
    return _objectSpread2({
      role: "form",
      noValidate: true,
      onSubmit: onSubmit
    }, htmlProps);
  }
});
var unstable_Form = createComponent({
  as: "form",
  useHook: unstable_useForm
});

export { unstable_Form, unstable_useForm };
